import dotenv from "dotenv";

const ErrorType = {
    NETWORK: 1,
    INVALID_PARAM: 2,
    NORMAL: 3,
    TIMEOUT: 4,
}
const FETCH_TIMEOUT = 30000;
const GET = 1;
const POST = 2;

let didTimeOut = false;

export default class CsStrapi {
    static url_base = '';

    static getBaseUrl() {
        if( this.url_base === '' ) {
            dotenv.config();
            this.url_base = (process.env.REACT_APP_STRAPI_URL) ? process.env.REACT_APP_STRAPI_URL : '';
        }
        return this.url_base;
    }

    static getNormal(resource, params) {
        const endpoint = this.getBaseUrl() + resource;
        const url = new URL(endpoint);
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        return fetch(url.href, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*'
            }
        }).then(res => res.json());
    }

    static get(operation, params, success, fail = null, retryCall=true, devTest = false, debugHandler = () => undefined) {
        didTimeOut = false;
        let endpoint = this.getBaseUrl() + operation;

        const url = new URL(endpoint);
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        let timeout = CsStrapi.getTimeOut(GET, operation, params, '', success, fail, retryCall, devTest);

        fetch(url.href, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*'
            }
        }).then(res => {
            return res.json();
        }).then(json => {
            debugHandler('Strapi: Fetch ok...', json);
            clearTimeout(timeout);
            if (!didTimeOut) {
                success(json);
            }
        }).catch(err =>  {
            clearTimeout(timeout);
            // If had timeout, do nothing, it will auto retry later. Otherwise, execute fail() handler
            if (!didTimeOut && fail) {
                fail({...err, type:ErrorType.NETWORK});
            }
        });
    }

    static post(operation, params, data, success, fail = null, retryCall=true, debugHandler = () => undefined) {
        didTimeOut = false;
        let endpoint = this.getBaseUrl() + operation;

        const url = new URL(endpoint);
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        let timeout = CsStrapi.getTimeOut(POST, operation, params, data, success, fail, retryCall);

        fetch(url.href, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*'
            }
        }).then(res => {
            clearTimeout(timeout);  // Has response, clear timeout
            return res.json();
        }).then(json => {
            if (json.statusCode === 200) {
                debugHandler('Strapi: Post ok...', json);
                success(json);
            } else {
                if (fail) {
                    fail({...json, type:ErrorType.NORMAL});
                }
            }
        }).catch(err =>  {
            // If had timeout, do nothing, it will auto retry later. Otherwise, execute fail() handler
            if (fail) {
                fail({...err, type:ErrorType.NETWORK});
            }
        });
    }

    static getTimeOut(type, operation, params, data, cbSuccess, cbError, retryCall, debug){
        return setTimeout(() => {
            didTimeOut = true;
            if (retryCall) {
                if (type === GET) {
                    CsStrapi.get(operation, params, cbSuccess, cbError, false, debug);
                } else {
                    CsStrapi.post(operation, params, data, cbSuccess, cbError, false)
                }
            } else {
                let json = {status: "Error", message: "Timed out to call API"};
                if(cbError){
                    cbError({...json, type: ErrorType.TIMEOUT});
                }
                console.log('Strapi: Timeout');
            }
        }, FETCH_TIMEOUT);
    }
}
